import { isWithinInterval } from 'date-fns';

import { Zeitraum } from '../../../../dtos.ts';
import { formatList } from '../../../../utils/dateFormat/listFormat.ts';
import { PlanningWarning } from '../../PlanningWarningDialog.tsx';
import { isGruppenraumEvent } from '../../ResourceCalendar/helperClasses/CalendarEvent/index.ts';
import { CalendarEvent } from '../../ResourceCalendar/index.ts';

export const getGruppenraumWarnings = (
  pendingEvents: readonly CalendarEvent[],
  gruppenraumNotwendigAnTagen: number[],
  ablauf: Zeitraum[],
): PlanningWarning[] => {
  const gruppenraumEvents = pendingEvents.filter(isGruppenraumEvent);

  const daysWithMissingGruppenraum = gruppenraumNotwendigAnTagen.filter(
    // gruppenraumNotwendig ist 1-basiert, ablauf ist 0-basiert
    (tag) => !hatGruppenraumBlockungForAblaufTag(ablauf[tag - 1], gruppenraumEvents),
  );

  if (daysWithMissingGruppenraum.length === 0) {
    return [];
  } else {
    return [
      {
        id: `missing-gruppenraum-${daysWithMissingGruppenraum.join('-')}`,
        title: 'Kein Gruppenraum ausgewählt',
        message: `Laut Planungsinformation wird an Tag ${formatList(daysWithMissingGruppenraum)} ein Gruppenraum benötigt, aber es wurde noch keiner ausgewählt.`,
      },
    ];
  }
};

const hatGruppenraumBlockungForAblaufTag = (
  ablaufTag: Zeitraum,
  gruppenraumEvents: readonly CalendarEvent[],
): boolean =>
  gruppenraumEvents.some((event) => isWithinInterval(event.start, ablaufTag) && isWithinInterval(event.end, ablaufTag));

export const getGruppenraumWarningsBL = (pendingEvents: readonly CalendarEvent[]): PlanningWarning[] => {
  if (pendingEvents.some(isGruppenraumEvent)) {
    return [];
  }

  return [
    {
      id: 'missing-gruppenraum-bl',
      title: 'Kein Gruppenraum ausgewählt',
      message:
        'Laut Planungsinformation wird für dieses Modul ein Gruppenraum benötigt, aber es wurde noch keiner ausgewählt.',
    },
  ];
};
